import React from 'react';

/**
 * Reusable Pagination Footer Component
 * Displays pagination controls with Previous/Next buttons
 * 
 * @param {Object} pageInfo - Pagination info object
 * @param {Function} onPrevious - Handler for previous page
 * @param {Function} onNext - Handler for next page
 * @param {boolean} loading - Loading state to disable buttons
 * @param {string} itemName - Name of items being paginated (default: 'products')
 */
function PaginationFooter({ pageInfo, onPrevious, onNext, loading = false, itemName = 'products' }) {
  // Always show pagination, even if there's only 1 page (with disabled buttons)
  if (!pageInfo) {
    return null;
  }

  // Calculate button states based on current page and total pages
  const hasPreviousPage = pageInfo.currentPage > 1;
  const hasNextPage = pageInfo.currentPage < pageInfo.totalPages;

  return (
    <div className="sticky-footer">
      <s-stack direction="inline" gap="base" alignItems="center" justifyContent="center">
        <s-button
          variant="secondary"
          icon="chevron-left"
          onClick={onPrevious}
          disabled={!hasPreviousPage || loading}
          accessibilityLabel="Previous page"
        />
        <s-text color="subdued">
          Page {pageInfo.currentPage} of {pageInfo.totalPages} ({pageInfo.totalProducts} {pageInfo.totalProducts === 1 ? itemName.slice(0, -1) : itemName})
        </s-text>
        <s-button
          variant="secondary"
          icon="chevron-right"
          onClick={onNext}
          disabled={!hasNextPage || loading}
          accessibilityLabel="Next page"
        />
      </s-stack>
    </div>
  );
}

export default PaginationFooter;
